import { httpClient } from "@/http";
import { DateRange } from "../common";

interface DashboardTotalDateRangeData {
  /** 代收顆數 */
  deposit: number;
  /** 代付顆數 */
  withdraw: number;
  /** 上存顆數 */
  tenant_deposit: number;
  /** 下發顆數 */
  tenant_withdraw: number;
  /** 顯示顆數 */
  profit: number;
}

interface DashboardDepositDateRangeData {
  created: {
    /** 已開單數 */
    count: number;
    /** 已開金額 */
    amount: number;
  };
  arrived: {
    /** 已繳單數 */
    count: number;
    /** 已繳金額 */
    amount: number;
  };
  /** 繳費率 */
  rate: number;
}

export interface DashboardChartDateRangeData {
  label: string;
  value: number;
}

export interface DashboardData {
  summary: {
    total: Record<DateRange, DashboardTotalDateRangeData>;
    deposit: Record<DateRange, DashboardDepositDateRangeData>;
  };
  chart: {
    deposit_in_24_hours: {
      /** 單數 */
      counts: DashboardChartDateRangeData[];
      /** 顆數 */
      amounts: DashboardChartDateRangeData[];
    };
    withdraw_in_24_hours: {
      /** 單數 */
      counts: DashboardChartDateRangeData[];
      /** 顆數 */
      amounts: DashboardChartDateRangeData[];
    };
  };
}

export const DashboardService = {
  read() {
    return httpClient<HttpResponse<DashboardData>>().get("/api/v1/dashboard");
  },
};
